import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { TacoTuesdaysComponent } from './taco-tuesdays.component';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule
  ],
  declarations: [
    TacoTuesdaysComponent,
  ],
  providers: [
  ]
})
export class TacoTuesdaysModule { }



// WEBPACK FOOTER //
// ./src/app/taco-tuesdays/taco-tuesdays.module.ts